import { Component, OnInit } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Location } from "src/app/models/Location";

@Component({
  selector: "app-location-create-modal",
  templateUrl: "./location-create-modal.component.html",
  styleUrls: ["./location-create-modal.component.scss"],
  standalone: false,
})
export class LocationCreateModalComponent implements OnInit {
  locationExist: boolean;
  locations: Location[];
  location: Location = new Location();

  constructor(
    public dialogRef: MatDialogRef<LocationCreateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Location[],
  ) {}

  ngOnInit() {
    this.locations = this.data;
  }

  onCreateLocation() {
    this.locationExist = this.locations.some((l) => l.locationName === this.location.locationName);

    if (this.locationExist) {
      return;
    }

    this.location.locationName = this.location.locationName.trim();
    this.dialogRef.close(this.location);
  }

  onCancel() {
    // no need to emit any result
    this.dialogRef.close();
  }
}
